import Charts from './Charts';
import CountryReferral from './CountryReferral';
import PriorityGroups from './PriorityGroups';
import React from 'react';
import SmartText from './SmartText';

const Content = (props) => {
  return (
    <div className='content'>
      <SmartText {...props} />
      <Charts {...props} />
      {/* <div className='section-spacer-internal' /> */}
      {/* <CountryReferral {...props} /> */}
      <div className='section-spacer' />
      <PriorityGroups {...props} />
    </div>
  );
};

export default Content;
